const preventDefault = e => void e.preventDefault();

export default preventDefault;
